import { useEffect } from "react";
import { setEvents, removeEvents } from "../utils/eventSetters";
import { IMain3DManager } from "../components/3d/main.3d.manager";
const useEvents = (
  main3DManager: IMain3DManager,
  canvasRef,
  listedVouchers
) => {

  useEffect(() => {
    if (main3DManager && canvasRef.current) {
      setEvents(main3DManager.eventService, canvasRef);

      return () => {
        if (main3DManager && main3DManager.eventService && canvasRef.current) {
          removeEvents(main3DManager.eventService, canvasRef);
        }
      };
    }
  }, [main3DManager, canvasRef]);

  return {};
};

export default useEvents;
